import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { switchy, useSetState, useArrayToggleState } from '../../utils'
import Analyze from './Analyze'
import History from './History'
import queryFormatOptions from './queryFormatOptions'
import { watchDueDiligenceHistory } from '../../fire'

let tabOptions = ['analyze', 'history']

let AdminDueDiligence = () => {
  let [activeTab, setActiveTab] = useState(tabOptions[0])
  let [analyzeState, setAnalyzeState] = useSetState({
    terms: '', // multi-line input
    // terms: `Concrete contractor
    // concrete services
    // concrete company`,
    termsArray: [],
    summary: [],
    running: false,
    progressPercent: 0,
    cityFilter: '',
    stateCodes: [],
    populationMin: '',
    populationMax: '',
    // stateCodes: ['UT'],
    // populationMin: 36000,
    // populationMax: 38000,
  })
  let queryFormatState = useArrayToggleState([queryFormatOptions[0].value])
  let selectedCityIndexesState = useArrayToggleState([])
  let savedHistoryIdsState = useArrayToggleState([])
  let [ddHistory, setHistory] = useState([])
  let [initialized, setInitialized] = useState(false)
  useEffect(() => {
    let watcherOff = watchDueDiligenceHistory(h => {
      setHistory(h)
      setInitialized(true)
    })

    return () => {
      watcherOff()
    }
  }, [])

  return (
    <div>
      <h4>Due Diligence</h4>
      <ul className="nav nav-tabs mb-3">
        {tabOptions.map(tab => (
          <li className="nav-item" key={tab}>
            <button
              onClick={() => setActiveTab(tab)}
              style={{ outline: '0', cursor: 'pointer' }}
              className={`nav-link ${
                activeTab === tab ? 'active' : 'border-bottom'
              }`}
              href="#"
            >
              {_.capitalize(tab)}
            </button>
          </li>
        ))}
      </ul>

      {switchy(activeTab, {
        analyze: () => (
          <Analyze
            state={analyzeState}
            setState={setAnalyzeState}
            queryFormatState={queryFormatState}
            selectedCityIndexesState={selectedCityIndexesState}
            savedHistoryIdsState={savedHistoryIdsState}
          />
        ),
        history: () =>
          !initialized ? (
            <i className="fa fa-spin fa-spinner fa-2x" />
          ) : (
            <History ddHistory={ddHistory} />
          ),
      })}
    </div>
  )
}

export default AdminDueDiligence
